export enum SigplaniModuloEnum {
  RDA = 0,
  GERENCIAMENTO = 1,
  FISCALIZACAO = 2
}
